import { FormElement } from './form-element';
import { FormElementValidators } from './form-element-validators';

export class Form {
    elements: FormElement[] = [];

    isValid(formElementValidator: FormElementValidators = null) {
        let isValid = true;

        for (var prop in this.elements) {
            isValid = this.elements[prop].isValid(formElementValidator) && isValid;
        }

        return isValid;
    }

    reset() {
        for (var prop in this.elements) {
            this.elements[prop].error.reset();
            this.elements[prop].value = undefined;
        }
    }
}
